import { Component } from '@angular/core';

@Component({
  selector: 'app-how-to-extract-pages-from-pdf',
  imports: [],
  templateUrl: './how-to-extract-pages-from-pdf.component.html',
  styleUrl: './how-to-extract-pages-from-pdf.component.css'
})
export class HowToExtractPagesFromPdfComponent {

}
